import {

  COMMON_NOTIFICATION,
  GET_COUNTRIES,
  SHOW_LOADER, 
  HIDE_LOADER
  
 
} from '../constants';

const initialState = {

  common_notification: {
    message: '',
    isSuccess: 1,
  },

  countries:[],
  loading: false,

};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {


    case COMMON_NOTIFICATION:
      return {
        ...state,
        common_notification: payload.message
          ? payload
          : initialState.common_notification,
      };

      case GET_COUNTRIES: {
      return {
        ...state,
        countries: payload,
      };
    }

     case SHOW_LOADER:
      return { loading: true };

    case HIDE_LOADER:
      return { loading: false };



    default:
      return state;
  }
};

export default reducer;
